export const AREASTATUSES = {
  OPEN: "OPEN",
  MEDIUM: "MEDIUM",
  CLOSED: "CLOSED",
};
